// @flow
import classnames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';

import AddParticipantIcon from '../../../assets/icons/add-participant-filled.svg';

const useStyles = makeStyles(theme => ({
  tooltipPlacementBottom: {
    margin: '20px 0',
  },
  addParticipantButton: {
    minWidth: 44,
    minHeight: 44,
    marginLeft: 4,
    marginRight: 4,
    marginTop: -4,
    padding: 10,
    backgroundColor: '#263252',
    border: 'none',
    outline: 'none',
    borderRadius: '50%',
    boxSizing: 'border-box',
    overflow: 'hidden',
    userSelect: 'none',
    '&:hover': {
      backgroundColor: theme.palette.ava.grey5,
    },
  },
  addParticipantButtonClicked: {
    backgroundColor: theme.palette.ava.deepBlue,
    pointerEvents: 'none',
  },
  addParticipantIcon: {
    width: '100%',
    height: '100%',
    marginLeft: 2,
  },
}));

interface Props {
  isActive: boolean;
  onClick: () => void;
}

const AddParticipantButton = ({ isActive, onClick }: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Tooltip
      classes={{
        tooltipPlacementBottom: classes.tooltipPlacementBottom,
      }}
      title={t('ccMode.participants.tooltip.addParticipant')}
      placement="bottom"
    >
      <button
        className={classnames(classes.addParticipantButton, {
          [classes.addParticipantButtonClicked]: isActive,
        })}
        onClick={onClick}
      >
        <img className={classes.addParticipantIcon} src={AddParticipantIcon} alt="" />
      </button>
    </Tooltip>
  );
};

export default AddParticipantButton;
